import { environment } from '@lentau/core/environments';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';

export interface State {
  // TODO: пустой интерфейс вызывает ошибку
  _empty?: boolean;
}

export const reducers: ActionReducerMap<State> = {};

export const metaReducers: MetaReducer<State>[] = environment.production ? [] : [];

export interface ActionType {
  BannerImage: string;
  BannerImageLarge: string;
  NewSiteBanner: string;
  NewSiteMainBanner: string;
  Description: string;
  FileParticipants: null; // ?
  FileRules: null; // ?
  FileWinners: null; // ?
  Finish: string;
  IsB2B?: boolean;
  GoodsCount: number;
  Id: string;
  Image: string;
  IsAllowHomeDelivery: boolean;
  IsParticipant: number;
  IsSet: boolean;
  Name: string;
  NameIsNotDisplayable: boolean;
  Position: string;
  Rules: string;
  ShowParticipateButton: number;
  Start: string;
  Url: string;
  YoutubeUrl: string;
  Type?: string; // AWAIT FOR RESOLVING FROM BE SIDE
  DescriptionBottom?: boolean;
}
